<template>
  <v-app>
    <div style="background-color: #0b253f">
      <!-- Page Wrapper -->
      <div id="page-wrapper">
        <!-- Header -->
        <header id="header" class="alt">
          <h1>
            <a href="index.html"
              ><img
                src="https://www.vstecs.co.th/th/isv/images/30th-vstecs-w-logo.png"
                alt=""
            /></a>
          </h1>
        </header>

        <!-- Banner -->

        <section id="banner">
          <div class="inner">
            <div class="image">
              <img
                src="https://www.vstecs.co.th/th/isv/images/30th-vstecs-logo-white.png"
                alt=""
              />
            </div>
            <h3>
              สมัครตัวแทนจำหน่าย<br />
              บริษัท วีเอสที อีซีเอส (ประเทศไทย) จำกัด
            </h3>

            <ul class="actions">
              <li>
                <a href="#register" class="button special">ลงทะเบียน</a>
              </li>
            </ul>
          </div>
          <a href="#one" class="more scrolly blue--text">เรียนรู้เพิ่มเติม</a>
        </section>

        <!-- One -->

        <section id="one" class="wrapper style1 special">
          <div class="inner">
            <header class="major">
              <h2>ทำไมจึงควรเลือกเป็นพันธมิตรกับ VST ECS (Thailand)</h2>

              <p>
                วีเอสที อีซีเอส (ประเทศไทย)
                มีสินค้าแบรนด์ชั้นนำระดับโลกและโซลูชันมากมายที่หลากหลาย <br />
                พร้อมให้ท่านเลือกนำไปจัดเซ็ทแพ็คเกจเพื่อนำไปเสนอให้ตรงกับความต้องการของลูกค้าได้อย่างสมบูรณ์แบบ
                <br />
                ตั้งแต่ระบบไอทีขนาดเล็กไปจนถึงระบบขนาดใหญ่บนระบบเอนเตอร์ไพรส์
              </p>
            </header>
          </div>
        </section>

        <!-- Two -->

        <section id="two" class="wrapper alt style5">
          <section class="spotlight">
            <div class="image">
              <img
                src="https://www.vstecs.co.th/th/isv/images/pic01.jpg"
                alt=""
              />
            </div>
            <div class="content">
              <h2>ทำไมจึงต้องมาสมัครเป็น VST ECS Dealer</h2>
              <p>
                เพื่อที่จะได้รับการสนับสนุนและรับสิทธิพิเศษมากมาย เช่น
                การซื้อสินค้าในราคาพิเศษ, <br />
                การเข้าฝึกอบรมความรู้ในเทคโนโลยีใหม่จากเจ้าของผลิตภัณฑ์
              </p>
            </div>
          </section>
        </section>

        <!-- Three -->
        <!-- 
        <section id="three" class="wrapper style3 special">
          <div class="inner">
            <header class="major">
              <h2>ทำไมจึงควรเลือกเป็นพันธมิตรกับ VST ECS (Thailand)</h2>

              <p>
                วีเอสที อีซีเอส (ประเทศไทย)
                มีสินค้าแบรนด์ชั้นนำระดับโลกและโซลูชันมากมายที่หลากหลาย <br />
                พร้อมให้ท่านเลือกนำไปจัดเซ็ทแพ็คเกจเพื่อนำไปเสนอให้ตรงกับความต้องการของลูกค้าได้อย่างสมบูรณ์แบบ
                <br />
                ตั้งแต่ระบบไอทีขนาดเล็กไปจนถึงระบบขนาดใหญ่บนระบบเอนเตอร์ไพรส์
              </p>
            </header>
          </div>
        </section>
-->
        <section id="cta" class="wrapper style4">
          <div class="inner">
            <header>
              <h2>ทำไมควรเข้าร่วมโปรแกรมโดยเร็ว</h2>
              <p>เพราะเป็นคำตอบที่ดีที่สุดสำหรับคุณ</p>
            </header>
            <ul class="actions vertical">
              <li>
                <a href="#register" class="button fit special">ลงทะเบียน</a>
              </li>
              <li><a href="#" class="button fit">เรียนรู้เพิ่มเติม</a></li>
            </ul>
          </div>
        </section>
        <a name="register"></a>
        <section class="wrapper style5">
          <div style="height: 500px">
            <v-container>
              <h4>Register Your Interest Now!</h4>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                      v-model="CompanyName"
                      :rules="CompanyNameRules"
                      :counter="40"
                      label="* ชื่อนิติบุคคล/Name of Juristic Person"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      v-model="CompanyRegNo"
                      :counter="13"
                      :rules="CompanyRegNoRules"
                      label="* เลขทะเบียนนิติบุคคล/Registration Certificate Number"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="Name"
                      :rules="NameRules"
                      label="* ชื่อ-นามสกุล/Full Name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="email"
                      :rules="emailRules"
                      label="* E-mail Address"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-col cols="3">
                    <v-text-field
                      v-model="Tel"
                      label="เบอร์ติดต่อกลับ/Mobile No."
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  Please specify product type regarding in dealer application

                  <v-spacer />
                  <v-col cols="2">
                    <v-switch
                      v-model="partnertype"
                      color="primary"
                      label="IT Products"
                      value="IT Products"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2">
                    <v-switch
                      v-model="partnertype"
                      color="primary"
                      label="EV Motorcycle"
                      value="EV Motorcycle"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2">
                    <v-switch
                      v-model="partnertype"
                      color="primary"
                      label="PET Products"
                      value="PET Products"
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6" />
                  <v-spacer />
                  <v-col cols="5">
                    <v-row>
                      <v-col cols="3">
                        <v-btn color="warning" @click="validate" class="mr-4">
                          CHECK
                        </v-btn>
                      </v-col>
                      <v-col cols="3">
                        <v-btn color="error" class="mr-4" @click="reset">
                          RESET
                        </v-btn>
                      </v-col>
                      <v-col cols="3">
                        <v-btn
                          :disabled="!valid || !vaClick || loadding"
                          color="success"
                          @click="submit"
                        >
                          SUBMIT
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </div>
        </section>
        <footer id="footer">
          <cookie-law theme="dark-lime" buttonText="ยอมรับ">
            <div slot="message">
              <div class="text-left">
                <h1>การใช้และการจัดการคุกกี้</h1>
                <span class="text-body-1">
                  บริษัทมีการใช้คุกกี้บนเว็ปไซต์ของบริษัทในการเก็บข้อมูลการใช้งานของท่าน
                  เพื่อมอบประสบการณ์ที่ดีในการใช้เว็ปไซต์และตรงตามความต้องการของลูกค้า
                  ท่านสามารถตั้งค่ายินยอมการใช้คุกกี้ได้โดยเข้าไปที่หน้าการตั้งค่าบราวเซอร์และตั้งค่าความเป็นส่วนตัว
                  และสามารถศึกษารายละเอียดเพิ่มเติมเกี่ยวกับ
                  <a
                    class="lime--text"
                    href="https://www.vstecs.co.th/th/index.php/pdpa"
                    target="_blank"
                    aria-label="Cookie Policy"
                    >นโยบายการใช้คุกกี้</a
                  >
                </span>
              </div>
            </div>
          </cookie-law>
          <ul class="copyright">
            สามารถติดต่อสอบถามข้อมูลเพิ่มเติมได้ที่ โทร. 02-032-9999 ต่อ 1023
            <p>
              Appication Versions 1.0.2 Copyright &copy; 2017 VST ECS (Thailand)
              Co., Ltd. All rights reserved.
            </p>
          </ul>
        </footer>
      </div>
    </div>
    <v-dialog v-model="ReturnRes" max-width="550px">
      <v-card v-if="SendComplete">
        <v-card-title class="headline"> การส่งข้อมูลเรียบร้อย</v-card-title>

        <v-card-text>
          บริษัทฯ ได้รับข้อมูลจากท่านแล้ว จะติดต่อกลับภายใน 3 ชั่วโมง (เวลาทำการ
          จันทร์-ศุกร์ เวลา 8.30น.-18.00น.) ตามอีเมล์ที่ท่านแจ้งไว้
          <p>
            หากไม่ได้รับการติดต่อกลับ กรุณาแจ้ง 02-032-9999 ต่อ 1023
          </p></v-card-text
        ><v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="retr"> OK </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title class="headline"> การส่งข้อมูลผิดพลาด </v-card-title>

        <v-card-text>
          การส่งข้อมูลผิดพลาดกรุณา กรุณาแจ้ง 02-032-9999 ต่อ 1023
          เพื่อรับการช่วยเหลือ</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="retr">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import CookieLaw from "vue-cookie-law";
export default {
  components: { CookieLaw },
  data: () => ({
    loadding: false,
    ReturnRes: false,
    SendComplete: false,
    valid: false,
    vaClick: false,
    CompanyName: "",
    CompanyRegNo: "",
    Name: "",
    Tel: "",
    partnertype: ["IT Products"],
    NameRules: [
      (v) => !!v || "Full Name is required",
      (v) => v.length >= 2 || "Full Name is required",
    ],
    CompanyNameRules: [
      (v) => !!v || "Company Name is required",
      (v) => v.length >= 5 || "Company name must more then 5 characters",
    ],
    CompanyRegNoRules: [
      (v) => !!v || "Registration Certificate Number is required",

      (v) => v.length == 13 || "Registration Certificate must be 13 characters",
      (v) =>
        Number.isInteger(Number(v)) ||
        "Registration Certificate must be number",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) =>
        /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "E-mail must be valid",
    ],
  }),
  created() {},
  methods: {
    retr() {
      this.ReturnRes = false;
      this.SendComplete = false;
      this.valid = false;
      this.vaClick = false;
      this.CompanyName = "";
      this.CompanyRegNo = "";
      this.Name = "";
      this.Tel = "";
      this.email = "";
      window.location.replace("https://www.vstecs.co.th");
    },
    validate() {
      this.$refs.form.validate();
      this.vaClick = true;
    },
    reset() {
      this.$refs.form.reset();
    },
    async senddata() {
      let rest = await axios.post("");
    },
    async submit() {
      this.loadding = true;
      this.$refs.form.validate();
      let SENDURL = process.env.VUE_APP_SUBMIT_API;
      if (this.valid) {
        let send = {
          CompanyName: this.CompanyName,
          CertificateNo: this.CompanyRegNo,
          FullName: this.Name,
          Email: this.email,
          TelNo: this.Tel,
          PartnerType: this.partnertype,
        };
        //console.log(send)
        let rest = await axios.post(SENDURL, send);

        if (rest.data.Status == "Compleate") {
          this.SendComplete = true;
          this.ReturnRes = true;
          this.loadding = false;
        } else {
          this.SendComplete = false;
          this.ReturnRes = true;
        }
      }
    },
  },
  watch: {
    valid(val) {
      if (!val) {
        this.vaClick = true;
      }
    },
  },
};
</script>
<style scoped></style>
